import { LandingPage } from './hero';

function Home() {
	return (
		<>
			<LandingPage />
		</>
	)
}
export { Home };